import { render } from "./HeroImageOverlay.vue?vue&type=template&id=0adb35da"
import script from "./HeroImageOverlay.vue?vue&type=script&lang=js"
export * from "./HeroImageOverlay.vue?vue&type=script&lang=js"
script.render = render

export default script